import React from 'react'
import { useTranslation } from 'react-i18next'
import ChipStatus from 'packages/ui/ChipStatus'
import { STATUS_CONFIG } from '../../../constants'

interface ProcessStatusProps {
  status: string
}

export const ProcessStatus: React.FC<ProcessStatusProps> = ({ status }) => {
  const { t } = useTranslation()
  const config = STATUS_CONFIG[status as keyof typeof STATUS_CONFIG]

  if (!config) {
    return null
  }

  return (
    <ChipStatus
      status={t(config.labelKey)}
      color={config.color}
      bgcolor={config.bgcolor}
      height={24}
      borderRadius="50px"
    />
  )
}